import { IGame } from "../Interfaces";

const heart: IGame = {
  "name": "Heart",
  "author": "Yihao",
  "time": new Date("2020-08-15T01:47:20.702Z"),
  "description": "This game resembles a beating heart.",
  "refreshFrequency": 2,
  "width": 15,
  "height": 15,
  "seeds": [
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      true,
      true,
      false,
      false,
      false,
      true,
      true,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      true,
      true,
      true,
      true,
      false,
      true,
      true,
      true,
      true,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      true,
      true,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ]
  ],
  "surviveRangeLower": 2,
  "surviveRangeUpper": 2,
  "reproductionRangeLower": 0,
  "reproductionRangeUpper": 0,
  "borderPolicy": "roll",
  "styles": [
    [
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#fcb4fe",
        "borderColor": "gray",
        "borderRadius": 30,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#fcb4fe",
        "borderColor": "gray",
        "borderRadius": 30,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#fcb4fe",
        "borderColor": "gray",
        "borderRadius": 30,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#fcb4fe",
        "borderColor": "gray",
        "borderRadius": 30,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#fcb4fe",
        "borderColor": "gray",
        "borderRadius": 30,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#fcb4fe",
        "borderColor": "gray",
        "borderRadius": 30,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#fcb4fe",
        "borderColor": "gray",
        "borderRadius": 30,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#fcb4fe",
        "borderColor": "gray",
        "borderRadius": 30,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#fcb4fe",
        "borderColor": "gray",
        "borderRadius": 30,
        "borderWidth": 0,
        "elevation": 0
      }
    ],
    [
      {
        "size": 100,
        "color": "#d061ce",
        "backgroundColor": "#fcb4fe",
        "borderColor": "gray",
        "borderRadius": 20,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 100,
        "color": "#d061ce",
        "backgroundColor": "#fcb4fe",
        "borderColor": "gray",
        "borderRadius": 20,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 100,
        "color": "#d061ce",
        "backgroundColor": "#fcb4fe",
        "borderColor": "gray",
        "borderRadius": 20,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 100,
        "color": "#d061ce",
        "backgroundColor": "#fcb4fe",
        "borderColor": "gray",
        "borderRadius": 20,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 100,
        "color": "#d061ce",
        "backgroundColor": "#fcb4fe",
        "borderColor": "gray",
        "borderRadius": 20,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 100,
        "color": "#d061ce",
        "backgroundColor": "#fcb4fe",
        "borderColor": "gray",
        "borderRadius": 20,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 100,
        "color": "#ce56cb",
        "backgroundColor": "#fcb4fe",
        "borderColor": "gray",
        "borderRadius": 20,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 100,
        "color": "#be43bb",
        "backgroundColor": "#fcb4fe",
        "borderColor": "gray",
        "borderRadius": 20,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 100,
        "color": "#a431a2",
        "backgroundColor": "#fcb4fe",
        "borderColor": "gray",
        "borderRadius": 20,
        "borderWidth": 0,
        "elevation": 0
      }
    ]
  ]
};

export default heart;